import isAnalysisGraphQLInternallyConsistent from 'analysis-tool/data/isAnalysisGraphQLInternallyConsistent';
import {assert} from 'Asserts';
import {getApolloClient} from 'graphql-client/ApolloClient';
import {isInaccessible} from 'graphql-client/InaccessibleInfo';

import {AnalysisGraphQL} from './AnalysisTypes';
import {GetAnalysis, GetAnalysisVariables} from './graphql/__generated/GetAnalysis';
import {GET_ANALYSIS_QUERY} from './graphql/GetAnalysis';

export default async function refreshAnalysis(analysisId: string): Promise<AnalysisGraphQL> {
  const result = await getApolloClient().query<GetAnalysis, GetAnalysisVariables>({
    query: GET_ANALYSIS_QUERY,
    variables: {
      analysisId,
    },
    fetchPolicy: 'network-only',
    /**
     * Do not let this forced refresh be de-duplicated against an in-flight auto-refresh, because the
     * in-flight auto-refresh may not contain the full updated data for which this forced refresh was
     * triggered.
     */
    context: {queryDeduplication: false},
  });
  assert(!isInaccessible(result.data.analysis), 'Tried to refresh an inaccessible analysis');

  if (!isAnalysisGraphQLInternallyConsistent(result.data.analysis)) {
    return refreshAnalysis(result.data.analysis.id);
  }

  return result.data.analysis;
}
